<template>
  <v-container style="display: flex; flex-direction: column; height: calc(-50px + 100vh); width: 100%; overflow: hidden;">
    <div style="display: flex; flex-direction: row; gap: 8px">
      <v-btn icon @click="$emit('navigate',undefined)">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <p class="v-card-title">{{ title }} - {{ item.name }}</p>
    </div>
    <hr>
    <v-container style="overflow-y: auto; flex: 1; padding-bottom: 150px">
      <data-card v-for="child in flattened" :bubbleItem="child" />
    </v-container>
  </v-container>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, onUnmounted } from "vue";
import "@livereader/graphly-d3/style.css";
import "@lr-notitia/bubbly-d3/style.css";
import DataCard from "./DataCard.vue";
import { BubblyItem } from "@lr-notitia/bubbly-d3";
import { flattenStructure } from "../../../../composables/bubblyPathCalculator";
import { useGraphStore } from "../../../../store/graph";
import { useSymbolsStore } from "../../../../store/symbols";
import { ConceptDataobject, InstanceDataobject } from "@lr-notitia/notitia-operator/schemas";

const compProps = defineProps<{
	item: BubblyItem;
  dataobjectId: string;
	isNested: boolean;
	parentId: string;
}>();
defineEmits(["navigate"]);

const flattened = computed(() => {
  return flattenStructure(compProps.item)
})

const graphStore = useGraphStore();
const symbolsStore = useSymbolsStore();

const dataobject = computed(() => {
	if (false) return graphStore.concept.dataobject.byId(compProps.dataobjectId);
	else return graphStore.instance.dataobject.byId(compProps.dataobjectId);
});

const title = computed(() => {
	if (!dataobject.value) return "";
	if (false) {
		return symbolsStore.term({
			id: (dataobject.value as ConceptDataobject).refersTo,
			terminology: (dataobject.value as ConceptDataobject).terminology,
		});
	} else {
		let concept = graphStore.concept.dataobject.byId((dataobject.value as InstanceDataobject).concept);
		if (!concept) return "";
		return symbolsStore.term({ id: concept.refersTo, terminology: concept.terminology });
	}
});

</script>